module.exports = __webpack_public_path__ + "media/images/webpage/hotels/3105/plan3-3-1b5739e49670ba0d468c08b7ff7ad111.webp";